import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { dispatch as storeDispatch } from '@store';
import { actions } from '@store/auth';
import { history } from '@history';
import { ApiService } from '@services/api';
import { ConstantsUtil } from '@utils';
import { Routes } from '@enums';

/**
 * Auth service.
 *
 * @author Yulian Kavaliou
 * @class AuthServiceClass
 * @category Services
 */
var AuthServiceClass = /*#__PURE__*/function () {
  function AuthServiceClass() {
    _classCallCheck(this, AuthServiceClass);
  }

  _createClass(AuthServiceClass, [{
    key: "getTokenLocalStorage",
    value:
    /**
     * Get token from local storage
     *
     * @author Mikhail Siutsou
     * @return {string} token.
     */
    function getTokenLocalStorage() {
      return localStorage.getItem('token');
    }
    /**
     * Get container from LS.
     *
     * @author Ihar Kazlouski
     */

  }, {
    key: "getContainerFromLs",
    value: function getContainerFromLs() {
      return localStorage.getItem(ConstantsUtil.localStorage.keysContainer);
    }
    /**
     * Get token from local storage
     *
     * @author Mikhail Siutsou
     * @param {string} token.
     */

  }, {
    key: "setTokenLocalStorage",
    value: function setTokenLocalStorage(token) {
      localStorage.setItem(ConstantsUtil.localStorage.token, token);
    }
    /**
     * Get token from session storage
     *
     * @author Mikhail Siutsou
     * @return {string} token.
     */

  }, {
    key: "getTokenSessionStorage",
    value: function getTokenSessionStorage() {
      return sessionStorage.getItem(ConstantsUtil.localStorage.token);
    }
    /**
     * Set token to session storage
     *
     * @author Mikhail Siutsou
     * @param {string} token.
     */

  }, {
    key: "setTokenSessionStorage",
    value: function setTokenSessionStorage(token) {
      sessionStorage.setItem(ConstantsUtil.localStorage.token, token);
    }
    /**
     * Remove token to session storage
     *
     * @author Mikhail Siutsou
     * @param {string} token.
     */

  }, {
    key: "removeTokenSessionStorage",
    value: function removeTokenSessionStorage() {
      sessionStorage.removeItem(ConstantsUtil.localStorage.token);
    }
    /**
     * Go to auth route
     *
     * @author Mikhail Siutsou
     */

  }, {
    key: "goToAuthRoute",
    value: function goToAuthRoute() {
      history.push(Routes.Login);
    }
    /**
     * Get current user api.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<User>>} current user response promise.
     */

  }, {
    key: "apiCurrentUserGet",
    value: function () {
      var _apiCurrentUserGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet("/admin-console-users/".concat(id), {
                  prefixURL: '/admin'
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiCurrentUserGet(_x) {
        return _apiCurrentUserGet.apply(this, arguments);
      }

      return apiCurrentUserGet;
    }()
    /**
     * Get current user api.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<User>>} current user response promise.
     */

  }, {
    key: "apiCurrentUserE2EGet",
    value: function () {
      var _apiCurrentUserE2EGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiGet("/current-user", {
                  prefixURL: '/e2e'
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiCurrentUserE2EGet() {
        return _apiCurrentUserE2EGet.apply(this, arguments);
      }

      return apiCurrentUserE2EGet;
    }()
    /**
     * Get current user.
     *
     * @author Ihar Kazlouski
     * @return {Promise<User | ApiErrorMessage>} current user response promise.
     */

  }, {
    key: "getCurrentUserE2E",
    value: function () {
      var _getCurrentUserE2E = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var dispatch;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch = storeDispatch;
                return _context3.abrupt("return", dispatch(actions.fetchUserE2ERequest()));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getCurrentUserE2E() {
        return _getCurrentUserE2E.apply(this, arguments);
      }

      return getCurrentUserE2E;
    }()
    /**
     * Get current user.
     *
     * @author Ihar Kazlouski
     * @return {Promise<User | ApiErrorMessage>} current user response promise.
     */

  }, {
    key: "getCurrentUser",
    value: function () {
      var _getCurrentUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var dispatch;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = storeDispatch;
                return _context4.abrupt("return", dispatch(actions.fetchUserRequest(id)));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getCurrentUser(_x2) {
        return _getCurrentUser.apply(this, arguments);
      }

      return getCurrentUser;
    }()
    /**
     * Get current user role api.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<Role[]>>} current user role response promise.
     */

  }, {
    key: "apiCurrentUserRoleGet",
    value: function () {
      var _apiCurrentUserRoleGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiGet("/role/".concat(id)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function apiCurrentUserRoleGet(_x3) {
        return _apiCurrentUserRoleGet.apply(this, arguments);
      }

      return apiCurrentUserRoleGet;
    }()
    /**
     * Get mlkem key api.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<Role[]>>} current user role response promise.
     */

  }, {
    key: "apiMlkemKeyGet",
    value: function () {
      var _apiMlkemKeyGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", ApiService.apiGet('/e2e/mlkem'));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function apiMlkemKeyGet() {
        return _apiMlkemKeyGet.apply(this, arguments);
      }

      return apiMlkemKeyGet;
    }()
    /**
     * Send user phone post api function.
     *
     * @author Ihar Kazlouski
     * @param {AxiosRequestConfig & { body: {phoneNumber: string} }} params axios params.
     * @return {Promise<ApiError | AxiosResponse<string>>} phone number response promise.
     */

  }, {
    key: "apiGetEntropyPost",
    value: function () {
      var _apiGetEntropyPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", ApiService.apiPost('/e2e/entropy', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({}, params)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function apiGetEntropyPost(_x4) {
        return _apiGetEntropyPost.apply(this, arguments);
      }

      return apiGetEntropyPost;
    }()
    /**
     * Send user phone post api function.
     *
     * @author Ihar Kazlouski
     * @param {AxiosRequestConfig & { body: {phoneNumber: string} }} params axios params.
     * @return {Promise<ApiError | AxiosResponse<string>>} phone number response promise.
     */

  }, {
    key: "apiSendOtpPost",
    value: function () {
      var _apiSendOtpPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", ApiService.apiPost('/e2e/key', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({}, params)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function apiSendOtpPost(_x5) {
        return _apiSendOtpPost.apply(this, arguments);
      }

      return apiSendOtpPost;
    }()
    /**
     * Get current permissions.
     *
     * @author Ihar Kazlouski
     * @return {Promise<User | ApiErrorMessage>} current permissions response promise.
     */

  }, {
    key: "getCurrentUserRole",
    value: function () {
      var _getCurrentUserRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id) {
        var dispatch;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                dispatch = storeDispatch;
                return _context9.abrupt("return", dispatch(actions.fetchUserRoleRequest(id)));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getCurrentUserRole(_x6) {
        return _getCurrentUserRole.apply(this, arguments);
      }

      return getCurrentUserRole;
    }()
    /**
     * Send user phone post api function.
     *
     * @author Ihar Kazlouski
     * @param {AxiosRequestConfig & { body: {phoneNumber: string} }} params axios params.
     * @return {Promise<ApiError | AxiosResponse<string>>} phone number response promise.
     */

  }, {
    key: "apiSendPhonePost",
    value: function () {
      var _apiSendPhonePost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", ApiService.apiPost('/auth', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({}, params), false));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function apiSendPhonePost(_x7) {
        return _apiSendPhonePost.apply(this, arguments);
      }

      return apiSendPhonePost;
    }()
    /**
     * Get container post api function.
     *
     * @author Ihar Kazlouski
     * @param {AxiosRequestConfig & { body: GetContainerPayload }} params axios params.
     * @return {Promise<ApiError | AxiosResponse<GetContainerResponse>>} get container response promise.
     */

  }, {
    key: "apiGetContainerPost",
    value: function () {
      var _apiGetContainerPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", ApiService.apiPost('/get-container', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/auth'
                }, params), false));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function apiGetContainerPost(_x8) {
        return _apiGetContainerPost.apply(this, arguments);
      }

      return apiGetContainerPost;
    }()
    /**
     * Api logout post.
     *
     * @author Ihar Kazlouski
     * @param {AxiosRequestConfig & { body: GetContainerPayload }} params axios params.
     * @return {Promise<ApiError | AxiosResponse<GetContainerResponse>>} logout promise.
     */

  }, {
    key: "apiLogoutPost",
    value: function () {
      var _apiLogoutPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", ApiService.apiPost('/logout', {}, _objectSpread({
                  prefixURL: '/auth'
                }, params)));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function apiLogoutPost(_x9) {
        return _apiLogoutPost.apply(this, arguments);
      }

      return apiLogoutPost;
    }()
  }]);

  return AuthServiceClass;
}();

var AuthService = new AuthServiceClass();
export { AuthService };